var xvision_type3 = {
    name: "Type3",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [67,0,4,165,2,179,1,168,2,44,6,109,35,45,17,159,2,0,0,63,181,85,171,127,106,162],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [67,0,4,167,2,183,1,163,2,42,6,130,35,43,17,160,2,0,0,63,181,85,170,191,234,162],
        },
        {
            function: "KEY_NICAM_A2",
            name: "KEY_NICAM_A2",
            icon: "KEY_NICAM_A2",
            command: [67,0,4,164,2,181,1,157,2,52,6,111,35,48,17,160,2,0,0,63,181,85,189,122,186,162],
        },
        {
            function: "KEY_ASPECT",
            name: "KEY_ASPECT",
            icon: "KEY_ASPECT",
            command: [67,0,4,164,2,179,1,160,2,51,6,135,35,36,17,161,2,0,0,63,181,85,174,190,186,162],
        },
        {
            function: "KEY_PMODE",
            name: "KEY_PMODE",
            icon: "KEY_PMODE",
            command: [67,0,4,162,2,179,1,162,2,54,6,101,35,21,17,157,2,0,0,63,181,85,182,189,186,162],
        },
        {
            function: "KEY_SMODE",
            name: "KEY_SMODE",
            icon: "KEY_SMODE",
            command: [67,0,4,163,2,178,1,160,2,53,6,110,35,45,17,158,2,0,0,63,181,85,171,95,186,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [67,0,4,164,2,181,1,157,2,52,6,112,35,35,17,155,2,0,0,63,181,85,175,250,170,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [67,0,4,161,2,180,1,157,2,53,6,114,35,48,17,155,2,0,0,63,181,85,183,246,170,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [67,0,4,168,2,177,1,157,2,54,6,135,35,33,17,156,2,0,0,63,181,85,171,254,170,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [67,0,4,167,2,177,1,159,2,52,6,141,35,44,17,156,2,0,0,63,181,85,187,245,170,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,166,2,177,1,159,2,52,6,112,35,38,17,158,2,0,0,63,181,85,173,253,170,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [67,0,4,163,2,181,1,160,2,51,6,118,35,45,17,157,2,0,0,63,181,85,181,251,170,162],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [67,0,4,167,2,180,1,156,2,51,6,116,35,38,17,159,2,0,0,63,181,85,170,255,170,162],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [67,0,4,162,2,183,1,159,2,50,6,133,35,38,17,160,2,0,0,63,181,85,189,245,106,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [67,0,4,167,2,175,1,166,2,48,6,117,35,46,17,164,2,0,0,63,181,85,174,253,106,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [67,0,4,172,2,174,1,166,2,47,6,116,35,49,17,162,2,0,0,63,181,85,191,234,170,162],
        },
        {
            function: "KEY_ENTERNUMBER",
            name: "KEY_ENTERNUMBER",
            icon: "KEY_ENTERNUMBER",
            command: [67,0,4,166,2,175,1,169,2,47,6,115,35,31,17,165,2,0,0,63,181,85,181,189,218,162],
        },
        {
            function: "KEY_RECALL",
            name: "KEY_RECALL",
            icon: "KEY_RECALL",
            command: [67,0,4,175,2,167,1,172,2,38,6,140,35,28,17,169,2,0,0,63,181,85,181,125,234,162],
        },
        {
            function: "KEY_FAV",
            name: "KEY_FAV",
            icon: "KEY_FAV",
            command: [67,0,4,180,2,162,1,176,2,39,6,135,35,28,17,171,2,0,0,63,181,85,191,117,86,162],
        },
        {
            function: "KEY_FREEZE",
            name: "KEY_FREEZE",
            icon: "KEY_FREEZE",
            command: [67,0,4,175,2,171,1,172,2,39,6,138,35,16,17,172,2,0,0,63,181,85,175,189,86,162],
        },
        {
            function: "KEY_TV_RADIO",
            name: "KEY_TV_RADIO",
            icon: "KEY_TV_RADIO",
            command: [67,0,4,174,2,163,1,180,2,40,6,133,35,21,17,171,2,0,0,63,181,85,183,187,86,162],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [67,0,4,174,2,168,1,178,2,38,6,131,35,252,16,171,2,0,0,63,181,85,174,222,182,162],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [67,0,4,176,2,167,1,172,2,39,6,138,35,16,17,171,2,0,0,63,181,85,170,239,214,162],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [67,0,4,175,2,166,1,177,2,39,6,155,35,15,17,170,2,0,0,63,181,85,181,221,214,162],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [67,0,4,174,2,168,1,176,2,39,6,142,35,25,17,171,2,0,0,63,181,85,189,186,182,162],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [67,0,4,174,2,165,1,176,2,39,6,132,35,18,17,169,2,0,0,63,181,85,170,223,218,162],
        },
        {
            function: "KEY_EPG",
            name: "KEY_EPG",
            icon: "KEY_EPG",
            command: [67,0,4,181,2,166,1,174,2,39,6,133,35,244,16,170,2,0,0,63,181,85,181,94,250,162],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,175,2,165,1,177,2,39,6,141,35,17,17,166,2,0,0,63,181,85,173,190,218,162],
        },
        {
            // function: "KEY_EXIT",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [67,0,4,181,2,164,1,175,2,38,6,142,35,17,17,169,2,0,0,63,181,85,190,186,174,162],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [67,0,4,174,2,164,1,181,2,38,6,136,35,16,17,169,2,0,0,63,181,85,171,111,182,162],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [67,0,4,176,2,164,1,179,2,39,6,143,35,10,17,166,2,0,0,63,181,85,173,111,118,162],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [67,0,4,175,2,167,1,176,2,39,6,143,35,11,17,170,2,0,0,63,181,85,186,221,118,162],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [67,0,4,172,2,167,1,173,2,44,6,141,35,12,17,154,2,0,0,63,181,85,181,110,246,162],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [67,0,4,175,2,166,1,168,2,46,6,141,35,20,17,157,2,0,0,63,181,85,170,183,246,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,182,2,162,1,174,2,37,6,134,35,16,17,171,2,0,0,63,181,85,171,191,90,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [67,0,4,172,2,163,1,183,2,38,6,134,35,23,17,171,2,0,0,63,181,85,183,123,90,162],
        },
        {
            function: "KEY_DISPLAY",
            name: "KEY_DISPLAY",
            icon: "KEY_DISPLAY",
            command: [67,0,4,173,2,166,1,178,2,38,6,136,35,21,17,171,2,0,0,63,181,85,182,251,106,162],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [67,0,4,175,2,164,1,179,2,39,6,126,35,25,17,171,2,0,0,63,181,85,187,122,218,162],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [67,0,4,178,2,166,1,164,2,48,6,133,35,24,17,154,2,0,0,63,181,85,175,125,90,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [67,0,4,179,2,164,1,170,2,41,6,142,35,14,17,161,2,0,0,63,181,85,190,245,90,162],
        },
        {
            function: "KEY_PLAYPAUSE",
            name: "KEY_PLAYPAUSE",
            icon: "KEY_PLAYPAUSE",
            command: [67,0,4,178,2,166,1,165,2,48,6,144,35,13,17,154,2,0,0,63,181,85,186,250,234,162],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [67,0,4,180,2,161,1,165,2,49,6,166,35,16,17,154,2,0,0,63,181,85,173,126,234,162],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,166,2,168,1,181,2,43,6,151,35,242,16,152,2,0,0,63,181,85,182,221,182,162],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [67,0,4,180,2,163,1,176,2,36,6,144,35,12,17,168,2,0,0,63,181,85,186,189,122,162],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [67,0,4,177,2,167,1,164,2,48,6,125,35,244,16,153,2,0,0,63,181,85,173,95,122,162],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [67,0,4,184,2,162,1,160,2,50,6,142,35,13,17,152,2,0,0,63,181,85,170,175,250,162],
        },
        {
            function: "KEY_TTX",
            name: "KEY_TTX",
            icon: "KEY_TTX",
            command: [67,0,4,184,2,161,1,166,2,46,6,144,35,238,16,153,2,0,0,63,181,85,171,223,86,162],
        },
        {
            function: "KEY_TSHIFT",
            name: "KEY_TSHIFT",
            icon: "KEY_TSHIFT",
            command: [67,0,4,170,2,168,1,172,2,45,6,158,35,11,17,152,2,0,0,63,181,85,187,186,214,162],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [67,0,4,178,2,166,1,175,2,37,6,135,35,11,17,175,2,0,0,63,181,85,173,222,214,162],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [67,0,4,179,2,166,1,174,2,38,6,140,35,18,17,168,2,0,0,63,181,85,175,94,174,162],
        },
        {
            function: "KEY_REC",
            name: "KEY_REC",
            icon: "KEY_REC",
            command: [67,0,4,177,2,165,1,179,2,37,6,170,35,11,17,168,2,0,0,63,181,85,183,93,174,162],
        },
        {
            function: "KEY_PVR",
            name: "KEY_PVR",
            icon: "KEY_PVR",
            command: [67,0,4,178,2,164,1,170,2,44,6,136,35,13,17,157,2,0,0,63,181,85,171,175,174,162],
        },
    ]
}
export default xvision_type3